const initMemberApplicant = () => {
  if (!document.querySelector('.data-show-trigger')) {
    return false;
  }
  // Show / Hide form fields
  window
    .addEventListener('load', function (e) {
      document
        .querySelector('.data-show-trigger')
        .dispatchEvent(new Event('change'));
    });
  document
    .querySelector('.data-show-trigger')
    .addEventListener('change', function (e) {
      let value = this.value;
      document.querySelectorAll('[data-show]').forEach(el => {
        el.style.display = 'none';
        el.querySelectorAll('input, select, textarea').forEach(input => {
          input.setAttribute('disabled', 'disabled');
        });
        if (value !== '' && el.dataset.show.includes(value)) {
          el.style.display = 'block';
          el.querySelectorAll('input, select, textarea').forEach(input => {
            input.removeAttribute('disabled');
          });
          el.querySelectorAll('.hidden-more').forEach(hiddenMore => {
            hiddenMore.querySelectorAll('input, select, textarea').forEach(input => {
              input.setAttribute('disabled', 'disabled');
            });
          });
        }
      });
    });
  // Add another links
  document
    .querySelectorAll('.hidden-more-trigger')
    .forEach(el => {
      el.addEventListener('click', function (e) {
        let hiddenWrapper = this.parentNode.closest('.hidden-more');
        Array.from(hiddenWrapper.querySelectorAll('.form-group')).some(el => {
          if (el.style.display !== 'block') {
            el.style.display = 'block';
            el.querySelectorAll('input, select, textarea').forEach(input => {
              input.removeAttribute('disabled');
            });

            // only first one which is not visible, then wait for another click
            return true;
          }
        });
      });
    });
};

module.exports = {initMemberApplicant};
